import Image from '@src/quince-site-common/src/domains/Image'
import ProductDynamicImage from '@src/quince-site-common/src/domains/ProductDynamicImage'
import ProductImage from '@src/quince-site-common/src/domains/ProductImage'
import { IProductVariantOption, ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'
import { get, templateInterpolate, transform, uniqueId } from '@src/utils/functions/utils'

// TODO-LOCALISATION: Needs to be handled if we support language based customization
// @i18n-ignore
export const DEFAULT_CUSTOMIZATION_CHAR = 'A'

const templateSettings = {
  interpolate: /{{([\s\S]+?)}}/g,
}

const template = (str: string) => templateInterpolate(str, templateSettings)

interface Options {
  char: string | undefined
  productId: number
  variantId?: number
  dynamicImages: ProductDynamicImage[]
}

export const ensureDynamicImageInCarousel = (imageList: ProductImage[], options: Options) => {
  const dynamicImageWrapper = options.dynamicImages.find(
    ({ shopifyProductId, shopifyVariantId }) =>
      options.productId == shopifyProductId && options.variantId == shopifyVariantId,
  )
  if (!dynamicImageWrapper) return imageList

  const type = get(dynamicImageWrapper, ['dynamicImageConfig', 'layers', 0, 'type'])
  const config = get(dynamicImageWrapper, ['dynamicImageConfig', 'layers', 0, 'config'])
  const layerPlaceholderCustomizations = get(dynamicImageWrapper, ['customizations', 'layers', 0, 'placeholders'], [])
  const sharedPlaceholderCustomizations = get(dynamicImageWrapper, ['customizations', 'shared', 'placeholders'], [])
  const placeholderCustomizations = [...sharedPlaceholderCustomizations, ...layerPlaceholderCustomizations]

  if (type != 'remoteImage' || !config.url) {
    console.warn('Unsupported dynamic image config: ', options.dynamicImages)
    return imageList
  }
  const placeholderMapping = transform(
    placeholderCustomizations,
    (result, item) => {
      if (item.value) {
        result[item.name] = item.value
      } else if (options[item.name]) {
        result[item.name] = options[item.name]
      }
    },
    {
      char:
        options.char ||
        get(
          placeholderCustomizations.find(item => item.name === 'char'),
          ['options', 0, 'value'],
          DEFAULT_CUSTOMIZATION_CHAR,
        ),
    },
  )
  const buildUrl = template(config.url.template)
  const src = buildUrl(placeholderMapping)
  const dynamicImage: ProductImage = new ProductImage({
    image: new Image({
      id: uniqueId('sdc-necklace-preview-'),
      description: '',
      url: src,
      // @i18n-ignore
      title: 'SDC Preview',
      fileName: 'sdcPreview',
      height: 100,
      width: 100,
    }),
    options: [],
    isDynamicImagePreview: true,
  })

  const imageIdx = imageList.findIndex((it: ProductImage) => it.isDynamicImagePreview)
  if (imageIdx >= 0) {
    imageList = [...imageList]
    imageList[imageIdx] = dynamicImage
  } else {
    imageList.unshift(dynamicImage)
  }

  return imageList
}
export const getImagesSortedByColor = (images: ProductImage[], selectedColor: string) => {
  const imagesWithSelectedColorOption: ProductImage[] = []
  const restImages: ProductImage[] = []
  images.forEach(image => {
    if (
      imagesWithSelectedColorOption.length < 2 &&
      image.options.some(option => option.name === 'Color' && option.values.includes(selectedColor))
    ) {
      imagesWithSelectedColorOption.push(image)
    } else {
      restImages.push(image)
    }
  })
  return [...imagesWithSelectedColorOption, ...restImages]
}

export const getProductImagesSelectedOptions = (initalSelectedOptionsFromServer: ProductVariantOption[], selectedOptionsFromPdpStateManager: IProductVariantOption[]) => { 
  const selectedOptions = selectedOptionsFromPdpStateManager?.length ? selectedOptionsFromPdpStateManager : initalSelectedOptionsFromServer?.map(so => ({ name: so.name, value: so.value }))
  return selectedOptions
}
